import React from "react";
import { Link } from "react-router-dom";
import { BsInstagram, BsFacebook, BsTwitter, BsLinkedin } from "react-icons/bs";
function Footer() {
  const gotoTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const socialLinks = [
    {
      href: "https://www.instagram.com/clubhosty_official/",
      icon: BsInstagram,
      label: "Instagram",
    },
    {
      href: "https://twitter.com/Clubhosty",
      icon: BsTwitter,
      label: "Twitter",
    },
    {
      href: "https://www.facebook.com/clubhosty",
      icon: BsFacebook,
      label: "Facebook",
    },
    {
      href: "https://www.linkedin.com/company/clubhosty",
      icon: BsLinkedin,
      label: "LinkedIn",
    },
  ];

  const socialIconStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(33, 162, 160, 0.08)",
    border: "1px solid rgba(33, 162, 160, 0.14)",
    color: "#21a2a0",
    transition: "transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease",
  };

  const socialTextStyle = {
    margin: "0 0 10px 0",
    color: "#1f2937",
    fontSize: "14px",
    fontWeight: 600,
    letterSpacing: "0.01em",
  };

  return (
    <>
      {/* ======= Footer ======= */}
      <footer id="footer">
        <div className="footer-newsletter section-bg">
          <div className="container">
            <div className=" d-flex justify-content-around align-items-center">
              <img
                className="footer-img"
                src="/assets/img/contact-us.png"
                alt=""
              />
              <div className="footer-content">
                <h4 className="ctaline">
                  <span>Ready to Get Started ?</span>
                </h4>
                <p>Our experts are here to assist you!</p>
                <div>
                  <span>Talk to a Specialist</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6 footer-contact px-10">
                <img
                  className="logo"
                  src="../assets/img/Logo.png"
                  alt="CHLogo"
                  style={{ height: "70px" }}
                />
                <br />
                <p>
                  Founded in 2020 with an aim to deliver the best web hosting in
                  India that's crafted for unmatched speed, high security and
                  24x7 support.
                </p>
                
                {/* Contact Information */}
                <div style={{ margin: "15px 0" }}>
                  <p style={{ margin: "5px 0", fontSize: "14px" }}>
                    <i className="bi bi-phone" style={{ marginRight: "8px" }}></i>
                    <a href="tel:+9101169310286" style={{ color: "inherit", textDecoration: "none" }}>+91 011 6931 0286</a>
                  </p>
                  <p style={{ margin: "5px 0", fontSize: "14px" }}>
                    Business Hours: 9 AM - 6 PM IST
                  </p>
                </div>
                
                <div
                  className="msme-img"
                  style={{ width: "12rem", marginTop: "16px" }}
                >
                  <img
                    src="/assets/img/msme.png"
                    alt="MSME Registered"
                    style={{ display: "block", width: "100%", height: "auto" }}
                  />
                </div>

                <div className="startup-fame-badge" style={{ marginTop: "16px" }}>
                  <a
                    href="https://startupfa.me/s/clubhosty?utm_source=www.clubhosty.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "inline-block" }}
                  >
                    <img
                      src="https://startupfa.me/badges/featured-badge-small.webp"
                      alt="ClubHosty - Featured on Startup Fame"
                      width="224"
                      height="36"
                      style={{ display: "block", maxWidth: "100%", height: "auto" }}
                    />
                  </a>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 footer-links">
                <h4>Our Service</h4>
                <ul>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/sharedHosting">Shared Hosting</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/affordable-cpanel-hosting">Cpanel Hosting</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/affordable-reseller-web-hosting">
                      Reseller Hosting
                    </Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/affordable-vps-hosting">VPS Server</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/dedicated-server">Dedicated Server</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/cloud-based-hosting-services">
                      Cloud Hosting
                    </Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/domain">Domain Name Search</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="https://my.clubhosty.com/cart.php?a=add&domain=transfer">
                      Domain Transfer
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-lg-2 col-md-6 footer-links">
                <h4>Company</h4>
                <ul>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/about">About Clubhosty</Link>
                  </li>

                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="https://my.clubhosty.com/register.php">
                      Create Account
                    </Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="https://my.clubhosty.com/index.php?rp=/login">
                      Client Login
                    </Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="https://my.clubhosty.com/index.php?rp=/password/reset">
                      Forgot Password
                    </Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/affiliate">Affiliate Program</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/data-centers">Data Centers</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/status">Server Status</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/blog">Blog</Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2 col-md-6 footer-links">
                <h4>Help</h4>
                <ul>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/nameserver">Find Nameserver</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/whois">WHOIS Lookup</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/ip-address">My IP Address</Link>
                  </li>
                  
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <a
                      href="https://in.lg.clubhosty.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      VPS Looking Glass
                    </a>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/contact">Contact Us</Link>
                  </li>
                </ul>
              </div>

              <div className="col-lg-2 col-md-6 footer-links">
                <h4>Policies</h4>
                <ul>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/privacypolicy">Privacy Policy</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/terms-and-conditions">Terms of Service</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/fair-usage-policy">Fair Usage Policy</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/refund-policy">Refund Policy</Link>
                  </li>
                  <li onClick={gotoTop}>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/sla">Service Level Agreement</Link>
                  </li>
                </ul>
                <br />
                <div>
                  <h4 style={socialTextStyle}>Follow us</h4>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      flexWrap: "nowrap",
                    }}
                  >
                    {socialLinks.map(({ href, icon: Icon, label }) => (
                      <a
                        key={label}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={label}
                        title={label}
                        style={socialIconStyle}
                        onMouseEnter={(event) => {
                          event.currentTarget.style.transform = "translateY(-2px)";
                          event.currentTarget.style.boxShadow =
                            "0 10px 18px rgba(33, 162, 160, 0.16)";
                          event.currentTarget.style.backgroundColor = "rgba(33, 162, 160, 0.14)";
                        }}
                        onMouseLeave={(event) => {
                          event.currentTarget.style.transform = "translateY(0)";
                          event.currentTarget.style.boxShadow = "none";
                          event.currentTarget.style.backgroundColor = "rgba(33, 162, 160, 0.08)";
                        }}
                      >
                        <Icon size={22} />
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container py-5">
          <div className="row">
            <div className="col-md-12">
              <div className="copyright">
                &copy; Copyright 2021-2025{" "}
                <strong>
                  <span>ClubHosty is MSME registered Company</span>
                </strong>
              </div>
            </div>
          </div>
          <div className="row d-none d-md-flex">
            <div className="col-md-12">
              <ul className="footernav">
                <li onClick={gotoTop}>
                  <Link to="/unlimited-hosting-policy">
                    Unlimited Hosting Policy
                  </Link>
                </li>
                <li onClick={gotoTop}>
                  <Link to="/accept-usage-policy">Acceptable Usage Policy</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/* End Footer */}
    </>
  );
}

export default Footer;
